module.exports = __webpack_public_path__ + "static/campaigns.c08c940b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/campaigns.svg
// module id = 458
// module chunks = 35783957827783